<template>

    <div id="header" class="level">
      <div class="title is-3 level-item">Investigative journalism: a discursive-evolutionary history of practice and form 1800-2020</div>
    </div>

</template>

<script>
    export default {
        name: "AppHeader"
    }
</script>

<style scoped>

  #header {
    background-image: url("../assets/img/larger-sepia.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .level {
    height: 100px;
  }

  .level-item {
   flex-shrink: 1;
    padding: 20px 10px;
  }


</style>
